import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import { CloseButton } from '../../atoms';
import { GlobalStyle, CloseButtonContainer, ModalDialog } from './styles.js';

export const Modal = ({
  shown,
  ariaLabel,
  onCloseModal,
  children,
  // @TODO: remove ariaHideApp when E2E/a11y testing is available
  ariaHideApp = true,
  mobileFullScreen,
}) => {
  return (
    <>
      <GlobalStyle mobileFullScreen={mobileFullScreen} />
      <ReactModal
        isOpen={shown}
        className="ModalContent"
        overlayClassName="ModalOverlay"
        onRequestClose={onCloseModal}
        contentLabel={ariaLabel}
        ariaHideApp={ariaHideApp}
      >
        <CloseButtonContainer>
          <CloseButton onClick={onCloseModal}></CloseButton>
        </CloseButtonContainer>
        <ModalDialog mobileFullScreen={mobileFullScreen}>
          {children}
        </ModalDialog>
      </ReactModal>
    </>
  );
};

Modal.displayName = 'Modal';

Modal.propTypes = {
  shown: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  ariaHideApp: PropTypes.bool,
  mobileFullScreen: PropTypes.bool,
};
